import { render, staticRenderFns } from "./RewardBirthDayGift.vue?vue&type=template&id=6786b40f"
import script from "./RewardBirthDayGift.vue?vue&type=script&lang=js"
export * from "./RewardBirthDayGift.vue?vue&type=script&lang=js"
import style0 from "./RewardBirthDayGift.vue?vue&type=style&index=0&id=6786b40f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports